import log from 'salvo-lite/log'
import 'dom-slider'

class MobileMenuParent {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-mobile-menu-parent'))
        this._child = elem.parentNode.querySelector(this._data.child)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const self = this
        this._elem.addEventListener('click', e => {
            if (window.innerWidth <= 1200) {
                e.preventDefault()
                self._child.slideToggle()
            }
        })
    }
}

export default MobileMenuParent



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MobileMenuParent.js